import * as React from "react";
import { useContext } from "react";
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import { FtlTab } from "./FtlTab/FtlTab";
import { LtlTab } from "./LtlTab/LtlTab";
import { RouteEditTab } from "../RouteEditTab";
import { EditProjectContext } from "../EditProjectContext";
import AddRoute from "../AddRoute";
import { ReadOnlyProps } from "../ReadOnlyProps";

export default function RightSide({ isReadOnly }: ReadOnlyProps) {
  const [selected, setSelected] = React.useState<number>(0);

  const { setRouteEditTabSelected } = useContext(EditProjectContext);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
    setRouteEditTabSelected(e.selected);
  };

  return (
    <div
      style={{
        paddingLeft: "1rem",
        width: "100%",
        position: "relative",
        zIndex: 1,
      }}
    >
      <TabStrip selected={selected} onSelect={handleSelect} style={{ minHeight: "435px" }}>
        <TabStripTab key={RouteEditTab.Ftl} title="FTL">
          <FtlTab isReadOnly={isReadOnly} />
        </TabStripTab>
        <TabStripTab key={RouteEditTab.Ltl} title="LTL">
          <LtlTab isReadOnly={isReadOnly} />
        </TabStripTab>
      </TabStrip>

      <div
        style={{
          position: "absolute",
          right: "0",
          top: "-20px",
          zIndex: 2,
        }}
      >
        <AddRoute isReadOnly={isReadOnly} />
      </div>
    </div>
  );
}
